"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Grid_1 = __importDefault(require("@modules/Grid"));
const Icon_1 = __importDefault(require("@modules/Icon"));
require("./style.scss");
const PageButton = ({ onClick, pageName, className = '' }) => {
    const handleClick = (event) => {
        if (onClick)
            onClick(event);
    };
    return ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ col: true, xs: "12", sm: "12", md: "4", lg: "4", xl: "3", xxl: "3", className: `pageButtonGroup ${className}` }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "pageButton", onClick: (event) => handleClick(event) }, { children: [(0, jsx_runtime_1.jsx)("span", { children: pageName }), (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: "play", className: "arrow_icon" })] })) })));
};
exports.default = PageButton;
